import { AuthLayout } from "~/screens/Auth/Layout/AuthLayout";
import { useProvidersQuery } from "~/services";
import { ProviderSelectionHeader } from "./Header";
import { ProviderContent } from "./ProviderContent";

type ProviderSelectionViewProps = {
  handleProviderSelect: (providerId: number) => void;
  stateId?: number | null;
  insuranceId?: number | null;
  visitType?: string;
  handleGoBack?: () => void;
};

export const ProviderSelectionView = ({
  handleProviderSelect,
  stateId,
  insuranceId,
  visitType,
  handleGoBack,
}: ProviderSelectionViewProps) => {
  const { data: providers } = useProvidersQuery(
    stateId,
    insuranceId,
    visitType,
  );
  return (
    <AuthLayout>
      <div className="md:mx-auto md:grid md:max-w-6xl md:grid-cols-2 md:gap-14 md:p-4 md:px-6">
        <aside>
          <ProviderSelectionHeader handleGoBack={handleGoBack} />
        </aside>

        <section>
          <ProviderContent
            handleProviderSelect={handleProviderSelect}
            providers={providers}
          />
        </section>
      </div>
    </AuthLayout>
  );
};
